// extracted by mini-css-extract-plugin
export var aboveInput = "_mk-0";
export var actionButton = "_mk-5";
export var actionButtonContainer = "_mk-1";
export var actionIcon = "_mk-6";
export var aiInfoContainer = "_mk-2";
export var attachmentWrapper = "_mk-7";
export var bold = "_mk-3";
export var checkIcon = "_mk-8";
export var clickingRecipientBar = "_mk-11";
export var commentThreadSwitch = "_mk-a";
export var draftImage = "_mk-b";
export var draftImageContainer = "_mk-c";
export var draftImages = "_mk-e";
export var editButton = "_mk-g";
export var editor = "_mk-f";
export var editorContainer = "_mk-y";
export var editorErrorTooltipWrapper = "_mk-9";
export var headerDivider = "_mk-h";
export var icon = "_mk-i";
export var info = "_mk-j";
export var internal = "_mk-n";
export var internalDivider = "_mk-k";
export var internalMessage = "_mk-l";
export var messageInputCard = "_mk-m";
export var messageInputForm = "_mk-o";
export var messageInputFormInternal = "_mk-p";
export var options = "_mk-q";
export var publicMessageCustomer = "_mk-s";
export var publicMessageMerchant = "_mk-r";
export var removeImageButton = "_mk-d";
export var replyButtons = "_mk-t";
export var showSignatureButton = "_mk-u";
export var spinner = "_mk-v";
export var verticalButtonDivider = "_mk-4";
export var visibilitySelector = "_mk-w";
export var warning = "_mk-x";
export var wrappingText = "_mk-z";
export var writingInternalNoteTopBorder = "_mk-10";